import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { MissingProgrammingRecordsService } from '../missing-programming-records.service';
import { MissingProgrammingRecordsFieldName, MissingProgrammingRecordsList } from '../missing-programming-records.types';

@Injectable()
export class MissingProgrammingRecordsListingDataSourceService implements ListingDataSource<MissingProgrammingRecordsList> {
  private readonly missingProgrammingRecordsService = inject(MissingProgrammingRecordsService);
  private readonly timezoneService = inject(TimezoneService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<MissingProgrammingRecordsList> {
    return this.missingProgrammingRecordsService.readList({
      ...tableState,
      filters: (tableState.filters ?? []).map(f => ({
        ...f,
        filteredValues:
          f.filterType === MissingProgrammingRecordsFieldName.DateTimeUTC && f.filteredValues.length === 2
            ? this.timezoneService.getShiftedDatepickerRangeStringified({
                start: new Date(f.filteredValues[0]),
                end: new Date(f.filteredValues[1])
              })
            : f.filteredValues
      }))
    });
  }
}
